import React from 'react';
import Link from 'next/link';

export default function ProductVariants({ variants = [] }) {
  return (variants || []).filter((variant) => Object.values(variant.values || {}).length > 1).map((variant) => (
    <div key={variant.name} className="mb-5">
      <p className="mb-2 text-xs font-bold text-krit-surface">{variant.name}</p>
      <div className="flex flex-wrap gap-2">
        {Object.values(variant.values).map((value) => <Link key={value.slug} href={`/produs/${value.slug}`} aria-current={value.active ? 'page' : undefined}
          className={`inline-flex min-h-[44px] items-center rounded-lg px-3 py-2 text-sm font-semibold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-krit-ink focus-visible:ring-offset-2 ${value.active ? 'bg-krit-ink text-white' : 'bg-krit-paper text-krit-surface hover:bg-gray-200'}`}>
          {value.value}
        </Link>)}
      </div>
    </div>
  ));
}
